import { initInstance, getChainIdFromRpcUrl, isContractNotDeployedError, } from '../../chains/evm/api';
import { AVAILABLE_EVM_CHAINS, THIRD_WEB_ID } from '../../wallet/chains';
import { WEB3_ADDRESS } from '../../wallet';
import { getFastestRpc, translateErrorMessage } from '../../utils/common';
export async function initEvmProvider(toast) {
    for await (const chain of AVAILABLE_EVM_CHAINS) {
        const chainInfo = WEB3_ADDRESS[chain];
        if (!chainInfo) {
            toast.error(`${chain} is missing chain configuration`);
            continue;
        }
        const fastestRpc = THIRD_WEB_ID
            ? `https://${chainInfo.chainId}.rpc.thirdweb.com/${THIRD_WEB_ID}`
            : await getFastestRpc(chainInfo.rpc, getChainIdFromRpcUrl);
        if (!fastestRpc) {
            toast.error(`${chain} doesn't have valid RPC`);
        }
        try {
            await initInstance(chain, chainInfo.contracts ?? [], fastestRpc ?? chainInfo.rpc[0], undefined);
        }
        catch (error) {
            if (isContractNotDeployedError(error)) {
                toast.error(error.message);
            }
            else {
                toast.error(`Failed to initialize ${chain} contracts: ${translateErrorMessage(error)}`);
            }
        }
    }
}
